import script from "./EmailItem.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailItem.vue?vue&type=script&setup=true&lang=js"

import "./EmailItem.vue?vue&type=style&index=0&id=0ad2e758&lang=css"
import "./EmailItem.vue?vue&type=style&index=1&id=0ad2e758&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ad2e758"]])

export default __exports__